module.exports = __webpack_public_path__ + "static/media/terms.f31a84f7.md";